export const ADJUST_ZOOM_TO_SCREEN = 'ADJUST_ZOOM_TO_SCREEN';
export const ZOOM_IN = 'ZOOM_IN';
export const ZOOM_OUT = 'ZOOM_OUT';
export const ZOOM_AT = 'ZOOM_AT';
